// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width:599.9px){[data-v-3e6c0d12] .dialog{align-self:flex-end}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
